import React from 'react'
import colors from '@sportninja/common/constants/appColors'

interface SpeedometerIconProps {
  size?: number
  color?: string
  className?: string
  title?: string
}

/**
 * Speedometer — the "Intermediate" skill level, and the neutral fallback for an
 * unknown level. Mirrors the mobile Player Finder's MaterialCommunityIcons
 * `speedometer` glyph so both platforms read the same.
 */
const SpeedometerIcon: React.FC<SpeedometerIconProps> = ({
  size = 16,
  color = colors.PRIMARY,
  className,
  title,
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      className={className}
      role={title ? 'img' : 'presentation'}
      aria-label={title}
      aria-hidden={title ? undefined : true}
      focusable='false'
    >
      {title ? <title>{title}</title> : null}
      <path
        d='M12 16q.825 0 1.413-.588T14 14q0-.2-.038-.4t-.112-.375L16.2 9.55q.275-.4.188-.875T15.9 7.9q-.4-.275-.875-.188t-.775.463l-2.6 3.25q-.05 0-.075-.012T11.5 11.4q-.825 0-1.412.587T9.5 13.4q0 .15.025.288t.075.287L7.4 16.75q-.3.35-.238.813t.413.737q.35.275.812.213t.738-.413L11.3 15.9q.15.05.325.075T12 16Zm-9 4q-.425 0-.712-.288T2 19v-7q0-2.075.788-3.9t2.137-3.175Q6.275 3.575 8.1 2.787T12 2q2.075 0 3.9.787t3.175 2.138Q20.425 6.275 21.212 8.1T22 12v7q0 .425-.288.713T21 20H3Z'
        fill={color}
      />
    </svg>
  )
}

export default SpeedometerIcon
